import PropTypes from 'prop-types';
import styles from './SkillsItem.module.scss';
import * as Icons from '@mui/icons-material';
import AnimatedWrapper from '../AnimatedWrapper/AnimatedWrapper';

const SkillsItem = ({ icon, title, description }) => {
  const Icon = Icons[icon];
  
  return (
    <div className={styles.skillsItem}>
      <AnimatedWrapper>
        <div className={styles.skillsItem__container}>
          <div className={styles.skillsItem__iconWrapper}>
            <Icon sx={{ fontSize: 40, color: 'inherit' }} />
          </div>
          <div className={styles.skillsItem__content}>
            <h3 className={styles.skillsItem__title}>{title}</h3>
            <p className={styles.skillsItem__description}>{description}</p>
          </div>
        </div>
      </AnimatedWrapper>
    </div>
  );
};

SkillsItem.propTypes = {
  icon: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired
};

export default SkillsItem;
